import useReduxSelector from 'hooks/store/useReduxSelector';
import { useLocation, useSearchParams } from 'react-router-dom';
import { IChildrenProps } from 'types/ChildrenProps';
import { decodeAuthToken } from 'utils/authenticationUtils';
import { useFeatureFlags } from 'utils/features';
import AuthenticateFromToken from './AuthenticateFromToken/AuthenticateFromToken';
import DotEnvBootstrap from './DotEnvBootstrap';
import Interop from './Interop';

const ADP_CONSENT_PATH = '/adp/callback-consent';

export const BeforeRoutes = ({ children }: IChildrenProps) => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { token } = useReduxSelector((state) => state.authentication);
  const session = useReduxSelector((state) => state.session);
  const urlTokenLoginDisabled = useFeatureFlags('URL_TOKEN_LOGIN_DISABLED');

  const decodedToken = decodeAuthToken(token || '');
  const { memberId: authMemberId } = decodedToken;

  const { REACT_APP_KEY } = process.env;

  const isAdpConsentRoute =
    location.pathname === ADP_CONSENT_PATH || location.pathname.startsWith(`${ADP_CONSENT_PATH}/`);
  const authorizeAllowed = !urlTokenLoginDisabled || isAdpConsentRoute;

  if (searchParams.has('authorize')) {
    return <Interop ignoreToken={!authorizeAllowed} />;
  } else if (token && (!session.isAuthenticated || authMemberId !== session.memberId)) {
    return <AuthenticateFromToken token={token} memberId={authMemberId} />;
  } else if (!session.isAuthenticated && REACT_APP_KEY) {
    return <DotEnvBootstrap />;
  } else {
    return <>{children}</>;
  }
};
